import React from 'react'

export const _renderUserMenuItemChildren = (user, props, index) => {
    // THIS METHOD ENABLES CUSTOM HIGHLIGHT FIELDS ON PROJECT LEAD/ANALYST TYPEAHEADS
    return [
        <div key="name" search={props.text}>
            <strong>{user.first_name} {user.last_name}</strong>
        </div>,
        <div key="email">
            <small>
                Email: {user.email ? user.email : "N/A"}
            </small>
        </div>,
    ]
}


// WEBPACK FOOTER //
// ./src/functions/reactTypeaheadRenderMenuItemChildren.js